import { TPopupInitialState, TPopupList } from '@@types/popup';
import {
  combineReducers,
  configureStore,
  PayloadAction,
  Reducer,
  ReducersMapObject,
} from '@reduxjs/toolkit';
import stores from '@stores/index';
import { HYDRATE } from 'next-redux-wrapper';
import { TAddressInitialState } from './address';
import { TCartInitialState } from './cart';
import { TEventInitialState } from './event';
import { TLoaderInitialState } from './loader';
import { TMyInfoInitialState } from './myInfo';
import { TOrderInitialState } from './order';
import { TRestaurantInitialState } from './restaurant';
import { TSocketInitialState } from './socket';

type ReducersType = {
  popup: TPopupInitialState<TPopupList>[];
  myInfo: TMyInfoInitialState;
  loader: TLoaderInitialState;
  address: TAddressInitialState;
  restaurant: TRestaurantInitialState;
  order: TOrderInitialState;
  socket: TSocketInitialState;
  cart: TCartInitialState;
  event: TEventInitialState;
};

const reducer = (state: ReducersType, action: PayloadAction<any>) => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return combineReducers(stores)(state, action);
};

const config = {
  reducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
} as {
  reducer:
    | Reducer<
        ReducersType,
        {
          payload: any;
          type: string;
        }
      >
    | ReducersMapObject<
        ReducersType,
        {
          payload: any;
          type: string;
        }
      >;
};

export const store = configureStore(config);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
